import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import { components as components200cm0ms, extraContent as extraContent200cm0ms } from "./components/200cm-0ms";
import { components as components200cm1_5ms, extraContent as extraContent200cm1_5ms } from "./components/200cm-1-5ms";
import { components as components200cm3_0ms, extraContent as extraContent200cm3_0ms } from "./components/200cm-3-0ms";
import { components as components50cm0ms, extraContent as extraContent50cm0ms } from "./components/50cm-0ms";
import { components as components50cm1_5ms, extraContent as extraContent50cm1_5ms } from "./components/50cm-1-5ms";
import { components as components50cm3_0ms, extraContent as extraContent50cm3_0ms } from "./components/50cm-3-0ms";
import { components as componentsNone0ms, extraContent as extraContentNone0ms } from "./components/none-0ms";
import { components as componentsNone1_5ms, extraContent as extraContentNone1_5ms } from "./components/none-1-5ms";
import { components as componentsNone3_0ms, extraContent as extraContentNone3_0ms } from "./components/none-3-0ms";

const principle: Slide = {
  description:
    "An Air Handling Unit (AHU) with a sound power level of Lw = 83dB(A) is installed into a room. Add a silencer and/or an outlet to it. Observe the changes in the octave band spectrum of generated noise, plotted against the NR curves, as well as the final NR values. Listen to the changes in the noise.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "dropdown",
          options: {
            label: "Silencer:",
          },
          items: [
            {
              name: "No silencer",
            },
            {
              name: "50 cm long",
            },
            {
              name: "200 cm long",
            },
          ],
        },
        {
          type: "dropdown",
          options: {
            label: "Airspeed through outlet:",
          },
          items: [
            {
              name: "0 m/s (no outlet)",
            },
            {
              name: "1.5 m/s",
            },
            {
              name: "3.0 m/s",
            },
          ],
        },
      ],
      extraContent: [
        [extraContentNone0ms, extraContentNone1_5ms, extraContentNone3_0ms],
        [extraContent50cm0ms, extraContent50cm1_5ms, extraContent50cm3_0ms],
        [extraContent200cm0ms, extraContent200cm1_5ms, extraContent200cm3_0ms],
      ],
      components: [
        [componentsNone0ms, componentsNone1_5ms, componentsNone3_0ms],
        [components50cm0ms, components50cm1_5ms, components50cm3_0ms],
        [components200cm0ms, components200cm1_5ms, components200cm3_0ms],
      ],
    },
  },
};

export default principle;
